import React from 'react';
import { Link } from 'react-router-dom';

class SimoDevicesList extends React.Component {
  render() {
    const {
      simoDevices,
      showUserId = true,
      viewUrl,
      actionComponent,
    } = this.props;

    return (
      <div>
        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              {showUserId && <th>User ID</th>}
              <th>Device SN</th>
              <th>Status</th>
              <th>Account</th>
              <th>Device Type</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {simoDevices.length > 0 ? (
              simoDevices.map((device) => (
                <tr key={device.id}>
                  <td>{device.id}</td>
                  {showUserId && <td>{device.user_profile}</td>}
                  <td>{device.serial_number}</td>
                  <td>{device.simo_status}</td>
                  <td>{device.account_name}</td>
                  <td>{device.device_type_name}</td>
                  <td>
                    {actionComponent ? (
                      actionComponent(device)
                    ) : (
                      <Link to={viewUrl(device.id)}>View</Link>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7}>No Results</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

export default SimoDevicesList;
